var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownGold = function SvgDropdownGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.333 14.937-.943.944-6.23-6.231-6.23 6.23-.943-.943 7.174-7.172z",
    fill: "#FFC83E",
    fillRule: "evenodd"
  })));
};
export { SvgDropdownGold as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xOS4zMzMgMTQuOTM3LS45NDMuOTQ0LTYuMjMtNi4yMzEtNi4yMyA2LjIzLS45NDMtLjk0MyA3LjE3NC03LjE3MnoiIGZpbGw9IiNGRkM4M0UiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";